// @flow
// eslint-disable-next-line import/prefer-default-export
export const compareJiraProjects = (newArr: Array, oldArr: Array): Object => {
    const create = newArr.filter(
        (newArrP) => !oldArr.find((oldArrP) => oldArrP.jiraProjectId === newArrP.jiraProjectId),
    );
    const remove = oldArr.filter(
        (oldArrP) => !newArr.find((newArrP) => newArrP.jiraProjectId === oldArrP.jiraProjectId),
    );
    return { create, remove };
};
